// Ensure $ refers to jQuery.
(function ($) {

    // Run this function on document ready event.
    $(function () {

        window.navCarouselRows = 3;
        window.navCarouselSlidesPerRow = 2;
        window.navCarouselSlidesPerGroup = navCarouselRows * navCarouselSlidesPerRow; // 6
        window.navCarouselVertical = ($(window).width() > 992);

        window.mainCarouselPrev = function (button) {

            // Show previous slide, with wraparound.
            var $carousel = $(button).parent().parent().find(".main-carousel");
            var slidesCount = $carousel.find(".slick-slide").length;
            var currentSlideIndex = $carousel.slick("slickCurrentSlide");
            var newSlideIndex = currentSlideIndex;
            if (currentSlideIndex > 0) {
                newSlideIndex = currentSlideIndex - 1;
            }
            else {
                newSlideIndex = slidesCount - 1;
            }
            $carousel.slick("slickGoTo", newSlideIndex);

            // Activate corresponding nav carousel slide and apply relevant classes.
            var $navCarousel = $carousel.parent().parent().find(".nav-carousel");
            var $navSlideGroups = $navCarousel.find(".slick-slide");
            var navSlideGroupsCount = $navCarousel.find(".slick-slide").length;
            var newNavSlideGroupIndex = Math.floor(newSlideIndex / navCarouselSlidesPerGroup);
            var newSlideWithinGroupIndex = newSlideIndex % navCarouselSlidesPerGroup;
            $navCarousel.slick("slickGoTo", newNavSlideGroupIndex);

            var $navCarouselSubSlides = $navCarousel.find(".carousel-slide");
            $navCarouselSubSlides.removeClass("nav-carousel-active");
            var $activeSlideGroup = $navSlideGroups.filter("[data-slick-index=\"" + newNavSlideGroupIndex + "\"]");
            var $activeSlide = $($activeSlideGroup.find(".carousel-slide")[newSlideWithinGroupIndex]);
            $activeSlide.addClass("nav-carousel-active");

            var $navCarouselContainer = $navCarousel.parent();
            $navCarouselContainer.removeClass("showing-first-slide");
            $navCarouselContainer.removeClass("showing-last-slide");
            if (newSlideIndex < navCarouselSlidesPerGroup) {
                $navCarouselContainer.addClass("showing-first-slide");
            }
            if (newSlideIndex >= ((navSlideGroupsCount - 1) * navCarouselSlidesPerGroup)) {
                $navCarouselContainer.addClass("showing-last-slide");
            }

        };

        window.mainCarouselNext = function (button) {

            // Show next slide, with wraparound.
            var $carousel = $(button).parent().parent().find(".main-carousel");
            var slidesCount = $carousel.find(".slick-slide").length;
            var currentSlideIndex = $carousel.slick("slickCurrentSlide");
            var newSlideIndex = currentSlideIndex;
            if (currentSlideIndex < slidesCount - 1) {
                newSlideIndex = currentSlideIndex + 1;
            }
            else {
                newSlideIndex = 0;
            }
            $carousel.slick("slickGoTo", newSlideIndex);

            // Activate corresponding nav carousel slide and apply relevant classes.
            var $navCarousel = $carousel.parent().parent().find(".nav-carousel");
            var $navSlideGroups = $navCarousel.find(".slick-slide");
            var navSlideGroupsCount = $navCarousel.find(".slick-slide").length;
            var newNavSlideGroupIndex = Math.floor(newSlideIndex / navCarouselSlidesPerGroup);
            var newSlideWithinGroupIndex = newSlideIndex % navCarouselSlidesPerGroup;
            $navCarousel.slick("slickGoTo", newNavSlideGroupIndex);

            var $navCarouselSubSlides = $navCarousel.find(".carousel-slide");
            $navCarouselSubSlides.removeClass("nav-carousel-active");
            var $activeSlideGroup = $navSlideGroups.filter("[data-slick-index=\"" + newNavSlideGroupIndex + "\"]");
            var $activeSlide = $($activeSlideGroup.find(".carousel-slide")[newSlideWithinGroupIndex]);
            $activeSlide.addClass("nav-carousel-active");

            var $navCarouselContainer = $navCarousel.parent();
            $navCarouselContainer.removeClass("showing-first-slide");
            $navCarouselContainer.removeClass("showing-last-slide");
            if (newSlideIndex < navCarouselSlidesPerGroup) {
                $navCarouselContainer.addClass("showing-first-slide");
            }
            if (newSlideIndex >= ((navSlideGroupsCount - 1) * navCarouselSlidesPerGroup)) {
                $navCarouselContainer.addClass("showing-last-slide");
            }
        };

        window.navCarouselPrev = function (button) {

            // Show previous nav carousel slide (group)
            var $carousel = $(button).parent().parent().find(".nav-carousel");
            var slidesCount = $carousel.find(".slick-slide").length;
            var currentSlideIndex = $carousel.slick("slickCurrentSlide");
            var newSlideIndex = currentSlideIndex;
            if (currentSlideIndex > 0) {
                newSlideIndex = currentSlideIndex - 1;
            }
            else {
                newSlideIndex = slidesCount - 1;
            }
            $carousel.slick("slickGoTo", newSlideIndex);

            // Apply relevant classes.
            var $navCarouselContainer = $carousel.parent();
            $navCarouselContainer.removeClass("showing-first-slide");
            $navCarouselContainer.removeClass("showing-last-slide");
            if (newSlideIndex < 1) {
                $navCarouselContainer.addClass("showing-first-slide");
            }
            if (newSlideIndex >= slidesCount - 1) {
                $navCarouselContainer.addClass("showing-last-slide");
            }

        };

        window.navCarouselNext = function (button) {

            // Show next nav carousel slide (group)
            var $carousel = $(button).parent().parent().find(".nav-carousel");
            var slidesCount = $carousel.find(".slick-slide").length;
            var currentSlideIndex = $carousel.slick("slickCurrentSlide");
            var newSlideIndex = currentSlideIndex;
            if (currentSlideIndex < slidesCount - 1) {
                newSlideIndex = currentSlideIndex + 1;
            }
            else {
                newSlideIndex = 0;
            }
            $carousel.slick("slickGoTo", newSlideIndex);

            // Apply relevant classes.
            var $navCarouselContainer = $carousel.parent();
            $navCarouselContainer.removeClass("showing-first-slide");
            $navCarouselContainer.removeClass("showing-last-slide");
            if (newSlideIndex < 1) {
                $navCarouselContainer.addClass("showing-first-slide");
            }
            if (newSlideIndex >= slidesCount - 1) {
                $navCarouselContainer.addClass("showing-last-slide");
            }

        };

        window.navCarouselNavigate = function (link) {

            var $slide = $(link).closest(".carousel-slide");
            var $carousel = $slide.closest(".nav-carousel");
            var $slides = $carousel.find(".carousel-slide");
            var $slideGroups = $carousel.find(".slick-slide");
            //var slideIndex = $slides.index($slide);
            var slideIndex = $slide.closest("[data-slick-index]").data("slick-index");
            if (navCarouselSlidesPerGroup > 1) {
                slideIndex = $slides.index($slide);
            }
            var $mainCarousel = $carousel.parent().parent().find(".main-carousel");
            var slideGroupIndex = Math.floor(slideIndex / navCarouselSlidesPerGroup);
            var slideWithinGroupIndex = slideIndex % navCarouselSlidesPerGroup;
            $mainCarousel.slick("slickGoTo", slideIndex);
            $carousel.slick("slickGoTo", slideGroupIndex);
            $slides.removeClass("nav-carousel-active");
            var $activeSlideGroup = $slideGroups.filter("[data-slick-index=\"" + slideGroupIndex + "\"]");
            var $activeSlide = $($activeSlideGroup.find(".carousel-slide")[slideWithinGroupIndex]);
            $activeSlide.addClass("nav-carousel-active");

            // Apply relevant classes.
            var $navCarouselContainer = $carousel.parent();
            $navCarouselContainer.removeClass("showing-first-slide");
            $navCarouselContainer.removeClass("showing-last-slide");
            if (slideGroupIndex < 1) {
                $navCarouselContainer.addClass("showing-first-slide");
            }
            if (slideGroupIndex >= $slideGroups.length - 1) {
                $navCarouselContainer.addClass("showing-last-slide");
            }

        };

        var $mainCarousels = $('.photo-gallery-carousel .main-carousel');
        var $navCarousels = $('.photo-gallery-carousel .nav-carousel');

        window.initPhotoGalleryCarouselBreakpoints = function (breakpoint) {
            if (breakpoint <= 992) {
                window.navCarouselRows = 1;
                window.navCarouselSlidesPerRow = 3;
                window.navCarouselSlidesPerGroup = 1; // no rows
                window.navCarouselVertical = false;
            }
            else if (breakpoint <= 1440) {
                window.navCarouselRows = 3;
                window.navCarouselSlidesPerRow = 1;
                window.navCarouselSlidesPerGroup = navCarouselRows * navCarouselSlidesPerRow; // 3
                window.navCarouselVertical = true;
            }
            else {
                window.navCarouselRows = 3;
                window.navCarouselSlidesPerRow = 2;
                window.navCarouselSlidesPerGroup = navCarouselRows * navCarouselSlidesPerRow; // 6
                window.navCarouselVertical = true;
            }
        };

        window.initPhotoGalleryCarousels = function () {

            initPhotoGalleryCarouselBreakpoints($(window).width());

            $mainCarousels.each(function (index) {
                $(this).prop("id", "photoGalleryCarousel" + index);
            });

            $navCarousels.each(function (index) {
                $(this).prop("id", "photoGalleryCarouselNav" + index);
            });

            $mainCarousels.each(function (index) {
                $(this).slick({
                    adaptiveHeight: true,
                    //asNavFor: "#photoGalleryCarouselNav" + index,
                    fade: true,
                    nextArrow: false,
                    prevArrow: false
                });
            });

            $navCarousels.each(function (index) {
                var $this = $(this);
                $this.slick({
                    centerMode: false,
                    infinite: false,
                    //mobileFirst: true,
                    nextArrow: false,
                    rows: 3,
                    prevArrow: false,
                    responsive: [
                        {
                            breakpoint: 1440,
                            settings: {
                                centerMode: false,
                                infinite: false,
                                rows: 3,
                                slidesPerRow: 1,
                                slidesToShow: 1,
                                vertical: true
                            }
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                centerMode: true,
                                infinite: true,
                                rows: 1,
                                slidesPerRow: 1,
                                slidesToShow: 3,
                                vertical: false
                            }
                        }
                    ],
                    slidesPerRow: 2,
                    slidesToShow: 1,
                    vertical: true
                });
                $this.on("breakpoint", function (event, slick, breakpoint) {
                    initPhotoGalleryCarouselBreakpoints($(window).width());
                });
                //var $firstSlide = $($this.find(".carousel-slide")[0]);
                var $firstSlide = $($this.find("[data-slick-index=\"0\"] .carousel-slide"));
                navCarouselNavigate($firstSlide);
            });

        };

        initPhotoGalleryCarousels();

    });

})(jQuery);